/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export function resolveSameOriginRedirectURL(
  rawRedirectURL: string | null | undefined,
  currentURL: string,
): string | null {
  const value = rawRedirectURL?.trim();
  if (!value) {
    return null;
  }

  try {
    const current = new URL(currentURL);
    const target = new URL(value, current);
    if (
      target.origin !== current.origin ||
      target.username ||
      target.password ||
      target.pathname.startsWith('//')
    ) {
      return null;
    }

    const resolved = `${target.pathname}${target.search}${target.hash}`;
    const currentPath = `${current.pathname}${current.search}${current.hash}`;
    return resolved === currentPath ? null : resolved;
  } catch {
    return null;
  }
}
